import { useQuery } from '@tanstack/react-query';
import { PrintTemplate } from '../models';
import QUERY_KEYS from '../utils/QueryKeys';

export default function usePrintTemplate() {
  return useQuery([QUERY_KEYS.PRINT_TEMPLATES, 10], () => (
    PrintTemplate
      .all()
      .then((res) => res.data)
  ));
}
